// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609301034/js/" + chunkId + "." + {"44":"7bf174de","225":"598773aa","481":"d444a607","486":"8021a4f5","770":"1d102246"}[chunkId] + ".0.10711865212841643.chunk.js";
};